"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    failedEndpoint: zod_1.z.enum([
        '/hub-maintenance',
        '/user-app-startup',
        '/has-agreed-to-current-acceptance-package',
    ]),
    errorType: zod_1.z.enum(['api_unreachable', 'maintenance_active']),
    userId: zod_1.z.number().nullable(),
});
exports.path = '/log-maintenance-event';
//# sourceMappingURL=index.js.map